import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store';
import * as styles from './styles.module.scss';
// FIXME
import {
  ContactIcon,
  PhonebookIcon,
  VirtualIcon,
} from '../../../app/components/icons';
import { getSha256Hash } from '../../helpers/util';

interface Props {
  email?: string;
  id?: string;
  type?: string;
  status?: string | boolean;
}

const ContactImage: React.FC<Props> = ({ email, id, type, status }) => {
  const linkedUsersMap = useSelector(
    (state: StoreState) => state.client.linkedUsersMap,
  );
  const [gravatarExists, setGravatarExists] = useState(true);
  const [hash, setHash] = useState<string>('');

  let contactEmail = id ? undefined : email;

  if (id && linkedUsersMap) {
    contactEmail = linkedUsersMap[id];
  }

  useEffect(() => {
    if (contactEmail) {
      getSha256Hash(contactEmail.trim().toLowerCase()).then(setHash);
    }
  }, [contactEmail]);

  let icon;

  switch (type) {
    case 'phonebookentry': {
      icon = <PhonebookIcon className={styles.icon} />;
      break;
    }
    case 'phone': {
      icon = <ContactIcon className={styles.icon} />;
      break;
    }
    case 'virtual': {
      icon = <VirtualIcon className={styles.icon} />;
      break;
    }
    default: {
      icon = <PhonebookIcon className={styles.icon} />;
      break;
    }
  }

  const showStatus = type === 'phone' && status !== false;

  let statusClass;
  let containerClass = styles.img_container;

  switch (status) {
    case 'ACTIVE': {
      statusClass = styles.status_active;
      break;
    }
    case 'INACTIVE': {
      statusClass = styles.status_inactive;
      break;
    }
    case 'RINGING': {
      statusClass = styles.status_ringing;
      containerClass = styles.img_container_ringing;
      break;
    }
    case 'UNKNOWN':
    default: {
      statusClass = styles.status_unknown;
      break;
    }
  }

  return (
    <div className={containerClass}>
      {contactEmail && hash && gravatarExists ? (
        <img
          src={`https://www.gravatar.com/avatar/${hash}?d=404`}
          className={styles.img}
          onError={() => {
            setGravatarExists(false);
          }}
          alt='Contact avatar'
        />
      ) : (
        icon
      )}
      {showStatus ? <div className={statusClass} /> : ''}
    </div>
  );
};

export default React.memo(ContactImage);
